import { apiErrorCode, $axios, API_URL, apiVersion, $axiosForm } from './axios.instance'

const StatusCode = apiErrorCode
export const checkUserValidation = (data) => {
  if (data && data.statusCode) {
    const { statusCode: stc } = data
    return (
      stc === StatusCode.sessionExpired ||
      stc === StatusCode.unauthorized ||
      stc === StatusCode.accessDenied
    )
  }
  return false
}

const getApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback,
  config = {}
) => {
  // 
  $axios
    .get(API_URL + apiVersion + endPoint + params, config)
    // .get(API_URL + endPoint + params, {})
    .then((res) => {
      successCallback(res)
    })
    .catch(async (err) => {
      if (err?.response?.data.statusCode === 401) {
        errorCallback(err.response.data)
      }
      if (err?.response?.status === 400 && err?.response &&
      err?.response?.data instanceof Blob &&
      err?.response?.data?.type === "application/json") {
        const text = await err?.response?.data?.text();
        const json = JSON.parse(text);
        errorCallback(json?.error || json?.message || json)
        return;
      }
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        errorCallback(err.response.data)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const postApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback,
  config = {}
) => {
  $axios
    .post(API_URL + apiVersion + endPoint, params, config)
    .then((res) => {
      successCallback(res)
      
    })
    .catch((err) => {
      
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        errorCallback(err.response)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const putApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback
) => {
  $axios
    .put(API_URL + apiVersion + endPoint, params)
    .then((res) => {
      successCallback(res)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        errorCallback(err.response)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const patchApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback
) => {
  $axios
    .patch(API_URL + apiVersion + endPoint, params)
    .then((res) => {
      successCallback(res)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        errorCallback(err.response)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const deleteApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback
) => {
  $axios
    .delete(API_URL + apiVersion + endPoint, params)
    .then((res) => {
      successCallback(res)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        
        errorCallback(err.response)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const postApiCallForm = (
  endPoint,
  params,
  successCallback,
  errorCallback
) => {
  $axiosForm
    .post(API_URL + apiVersion + endPoint, params)
    .then((res) => {
      successCallback(res)
      
    })
    .catch((err) => {
      
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        errorCallback(err.response)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const patchApiCallForm = (
  endPoint,
  params,
  successCallback,
  errorCallback
) => {
  $axiosForm
    .patch(API_URL + apiVersion + endPoint, params)
    .then((res) => {
      successCallback(res)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        errorCallback({
          data: {
            statusCode: 408
          }
        })
      } else if (err.response && !checkUserValidation(err.response.data)) {
        errorCallback(err.response)
      } else if (!err.response) {
        errorCallback({
          data: {
            statusCode: '',
            message: 'Please try again later'
          }
        })
      }
    })
}

const api = {
  getApiCall,
  postApiCall,
  putApiCall,
  patchApiCall,
  deleteApiCall,
  postApiCallForm,
  patchApiCallForm
}
export default api
